import { createApi } from '@reduxjs/toolkit/query/react';
import type { IApplication } from '../types/ApplicationsTypes';
import { baseQuery, getBaseQueryWithReauth } from '../baseQueryAuth';

export const ApplicationsApi = createApi({
  reducerPath: 'ApplicationsApi',
  baseQuery: getBaseQueryWithReauth(baseQuery),
  tagTypes: ['Applications'],
  endpoints: (build) => ({
    getApplications: build.query<IApplication[], void>({
      query: () => ({
        url: '/merchant/appilactions/',
        method: 'GET',
      }),
      providesTags: ['Applications'],
    }),
  }),
});

export const { useGetApplicationsQuery } = ApplicationsApi;
